import { render, staticRenderFns } from "./Mepandes.vue?vue&type=template&id=a0f30d7a&scoped=true&"
import script from "./Mepandes.vue?vue&type=script&lang=js&"
export * from "./Mepandes.vue?vue&type=script&lang=js&"
import style0 from "./Mepandes.vue?vue&type=style&index=0&id=a0f30d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f30d7a",
  null
  
)

export default component.exports